<img src="./assets/img/successImg.svg" alt="">
<div class="text">
    <div>{{'THANK_YOU_PAGE.TITLE' | translate}} </div>
    <div class="remark">{{'THANK_YOU_PAGE.REMARK_1' | translate}}</div>
    <div class="remark">{{'THANK_YOU_PAGE.REMARK_2' | translate}}</div>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
